import { render } from "./VabeneTvaReport.vue?vue&type=template&id=8a7abe32&scoped=true&ts=true"
import script from "./VabeneTvaReport.vue?vue&type=script&lang=ts"
export * from "./VabeneTvaReport.vue?vue&type=script&lang=ts"

import "./VabeneTvaReport.vue?vue&type=style&index=0&id=8a7abe32&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a7abe32"]])

export default __exports__